/*
 * Karigur — editorial auto-linker.
 * Weaves the FIRST mention of key bridal terms in article/craft bodies into links:
 *   silhouettes → the silhouette guide, crafts → their Craft Library term,
 *   ceremonies → their collection. One link per term per article, capped, never
 *   self-linking, never inside headings/existing links. Uses the .kb-ulink
 *   animated underline. Runs only on [data-kb-autolink] bodies + article-template RTE.
 */
(function () {
  'use strict';

  var TERMS = [
    { word: 'gharara', url: '/blogs/craft-library/gharara-sharara-lehenga-guide' },
    { word: 'sharara', url: '/blogs/craft-library/gharara-sharara-lehenga-guide' },
    { word: 'lehenga', url: '/blogs/craft-library/gharara-sharara-lehenga-guide' },
    { word: 'zardozi', url: '/blogs/craft-library/zardozi-embroidery-guide' },
    { word: 'dabka', url: '/blogs/craft-library/dabka-nakshi-embroidery' },
    { word: 'nakshi', url: '/blogs/craft-library/dabka-nakshi-embroidery' },
    { word: 'resham', url: '/blogs/craft-library/resham-silk-thread-embroidery' },
    { word: 'kamdani', url: '/blogs/craft-library/kamdani-mukaish-work' },
    { word: 'mukaish', url: '/blogs/craft-library/kamdani-mukaish-work' },
    { word: 'gota', url: '/blogs/craft-library/gota-work-guide' },
    { word: 'kaam', url: '/blogs/craft-library/kaam-density-bridal-pricing' },
    { word: 'tilla', url: '/blogs/craft-library/tilla-embroidery-guide' },
    { word: 'sitara', url: '/blogs/craft-library/sitara-work-guide' },
    { word: 'vasli', url: '/blogs/craft-library/vasli-foundation-guide' },
    { word: 'adda', url: '/blogs/craft-library/adda-work-guide' },
    { word: 'khaka', url: '/blogs/craft-library/khaka-embroidery-map' },
    { word: 'sheesha', url: '/blogs/craft-library/sheesha-mirror-work-guide' },
    { word: 'cutdana', url: '/blogs/craft-library/cutdana-beadwork-guide' },
    { word: 'aari', url: '/blogs/craft-library/aari-embroidery-guide' },
    { word: 'kora', url: '/blogs/craft-library/kora-matte-gold-guide' },
    { word: 'moti', url: '/blogs/craft-library/moti-pearl-work-guide' },
    { word: 'jamawar', url: '/blogs/craft-library/jamawar-fabric-guide' },
    { word: 'banarsi', url: '/blogs/craft-library/banarsi-fabric-guide' },
    { word: 'nikkah', url: '/collections/nikkah' },
    { word: 'mehndi', url: '/collections/mehndi' },
    { word: 'baraat', url: '/collections/baraat' },
    { word: 'walima', url: '/collections/walima' }
  ];
  var MAX_LINKS = 20;

  var here = location.pathname.replace(/\/+$/, '');
  var terms = TERMS.filter(function (t) { return t.url.replace(/\/+$/, '') !== here; });

  function eligible(node) {
    var p = node.parentElement;
    while (p && p !== document.body) {
      var tag = p.tagName;
      if (tag === 'A' || tag === 'BUTTON' || tag === 'CODE' || /^H[1-6]$/.test(tag)) return false;
      p = p.parentElement;
    }
    return true;
  }

  function linkContainer(container) {
    var used = {};
    var count = 0;
    terms.forEach(function (t) {
      if (count >= MAX_LINKS || used[t.url]) return;
      var rx = new RegExp('\\b(' + t.word + ')\\b', 'i');
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var val = node.nodeValue;
        if (!val) continue;
        var m = val.match(rx);
        if (!m) continue;
        if (!eligible(node)) continue;
        var before = val.slice(0, m.index);
        var after = val.slice(m.index + m[0].length);
        var a = document.createElement('a');
        a.href = t.url;
        a.className = 'kb-ulink kb-autolink';
        a.textContent = m[0];
        var frag = document.createDocumentFragment();
        if (before) frag.appendChild(document.createTextNode(before));
        frag.appendChild(a);
        if (after) frag.appendChild(document.createTextNode(after));
        node.parentNode.replaceChild(frag, node);
        used[t.url] = true;
        count++;
        break;
      }
    });
  }

  function init() {
    var containers = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-kb-autolink]'), function (c) { containers.push(c); });

    var main = document.getElementById('MainContent');
    var tmpl = main && main.getAttribute('data-template');
    if (main && tmpl && tmpl.indexOf('article') === 0) {
      Array.prototype.forEach.call(main.querySelectorAll('.rte'), function (rte) {
        if (rte.closest('[data-kb-autolink]')) return;
        if ((rte.textContent || '').length > 400) containers.push(rte);
      });
    }
    containers.forEach(linkContainer);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
